(function () {
    'use strict';

    angular
        .module('app')
        .controller('viewPdf', viewPdf);

    viewPdf.$inject = ['$window', '$stateParams', 'loginService', 'downloadService', '$location'];

    function viewPdf($window, $stateParams, loginService, downloadService, $location) {
        /* jshint validthis:true */
        var vm = this;
        vm.title = 'viewPdf';
        vm.loginService = loginService;
        var items = [];
        items.push(JSON.parse($stateParams.fileInfo));
        var slx = { mode: 0, order: 0, list: items };
        vm.error = "";
        vm.processing = true;
        // Call download.
        var options = { IncludeChildren: false, ZipFiles: false, ZipPassword: "" };
        downloadService.DownloadForIpad(options, slx).then(function (response) {
            // Handle download errors.
            vm.processing = false;
            var atLeastOneError = false;
            angular.forEach(response.data, function (item) {
                // If there was an error, report it and exit.
                if (item.ReturnErrorCode != 0) {
                    gridDataService.processing = false;
                    var errMsg = item.si.errFullErrStr;
                    var title = loginService.resourceStrings["VIEW_IPAD_UI_HEADING"]; // "iPad Viewer"
                    vm.error = { title: title, message: errMsg, type: 2 };
                }
                else { // Otherwise we can navigate to the file now.
                    var fileUrl = item['FileUrl'];
                    if (fileUrl) {
                        $window.location.href = fileUrl;
                    }
                    
                    return;
                }
            });
        }, function (response) {
            // Error occurred in download
            vm.processing = false;
            console.log(response);
            var errMsg = response.data['Message'];
            //alert(errMsg);
            var title = loginService.resourceStrings["VIEW_IPAD_UI_HEADING"]; // "iPad Viewer"
            var type = 3;
            if (response.status == 501 || response.status == 502) type = 2;
            vm.error = { title: title, message: errMsg, type: type };
        });



    }
})();
